export default {
  name: 'AdnButton',
  props: {
    kind: {
      type: String,
      default: 'primary',
      validator: val => ['primary', 'secondary', 'link'].includes(val)
    },
    iconName: {
      type: String,
      default: ''
    },
    iconPosition: {
      type: String,
      default: 'right',
      validator: val => ['right', 'left'].includes(val)
    },
    markup: {
      type: String,
      default: 'button',
      validator: val => ['button', 'router-link', 'div', 'span', 'a'].includes(val)
    },
    route: {
      type: [String, Object],
      default: '/'
    }
  },
  computed: {
    classNames() {
      const classNames = [`adn-button--${this.kind.toLowerCase()}`]
      return classNames
    },
    iconClassNames() {
      const iconClassNames = ['adn-icon', `adn-icon--${this.iconName.toLowerCase()}`]
      return iconClassNames
    },
    iconsPositionIsRight() {
      return this.iconPosition === 'right'
    }
  },
  methods: {
    onClick(event) {
      return this.$emit('click', event)
    }
  }
}
